
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

interface PropertyDescriptionFormProps {
  description: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const PropertyDescriptionForm = ({
  description,
  onChange
}: PropertyDescriptionFormProps) => {
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="space-y-4">
          <h2 className="text-xl font-semibold">Description</h2>
          <Separator />
          
          <div className="space-y-2">
            <Label htmlFor="description">Property Description</Label>
            <Textarea 
              id="description" 
              name="description"
              value={description}
              onChange={onChange}
              className="min-h-[150px] bg-muted" 
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
